<template>
  <div class="site_management">
    <van-sticky offset-top="0">
      <van-nav-bar title="收藏列表" left-arrow @click-left="goback()" />
      <div class="management_search">
        <van-search v-model="searchValue" show-action placeholder="输入场地名称搜索">
          <template #action>
            <div @click="onClickButton">搜索</div>
          </template>
        </van-search>
      </div>

    </van-sticky>


    <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <!-- 列表菜单栏 -->
        <div class="home_list">
          <div class="list_item" v-for="(item, index) in siteList" :key="index" @click="toSiteDetail(item.id)" >
            <div class="item_content">
              <div class="content_img">
                <van-image height="100%" width="100%"
                  :src="item.videoList.length > 0 ? item.videoList[0].thumbnailUrl : item.coverImageUrl" fit="cover" />

                <div v-if="item.shelfStatus != '1'">
                  {{ item.shelfStatus_name }}
                </div>

                <van-icon v-if="item.shelfStatus === '1' && item.videoList.length > 0" name="play" color="#fff"
                  size="15" />

              </div>

              <div class="content_detail">
                <div class="fs15 line1 font-weightbold">
                  {{ item.name }}
                </div>
                <div class="fs11 color666 p-b10">
                  {{ item.district }}•{{ item.address }}
                </div>
                <div class="detail_tag line1">
                  <van-tag color="#1A85D2" plain v-for="site in item.siteCharacteristics_name" :key="site">{{ site }}
                  </van-tag>
                </div>
                <div class="detail_number">
                  <div class="number">
                    <div class="fs16 coloree0a24">{{ item.monthlyRent }}</div>
                    <div class="fs12 coloree0a24">元/㎡/月</div>
                    <div class="fs14 color000 m-l20">{{ item.area }}㎡</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="item_action">
              <div
                :style="{ color: item.shelfStatus === '1' ? '#000' : '#fff' }"
              >
                展示中
              </div>
              <div class="action">
                <van-button
                  class="action_delete"
                  size="small"
                  color="#D0D0D0"
                  @click="siteDelete(item.id)"
                  >删除</van-button
                >
                <van-button
                  size="small"
                  type="default"
                  @click="siteShelfStatus(item.id)"
                  >{{ item.shelfStatus === "1" ? "下架" : "上架" }}</van-button
                >
                <van-button
                  size="small"
                  type="info"
                  @click="toPlaceEdit(item.id)"
                  >编辑</van-button
                >
              </div>
            </div> -->

          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <!-- <van-button color="#0CA7F0" class="management_push" type="primary" block @click="toPlaceIssue()">创建场地</van-button> -->
  </div>
</template>    

<script>
import { Button, Icon, Image, Tag, List, PullRefresh, Search } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Search.name]: Search,
  },
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        size: 8,
      },
      //场地方列表
      siteList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
      searchValue: '',
    };
  },

  created() {
    // 场地方管理-列表
    this.listBySiteSupplierId();
  },

  methods: {

  toSiteDetail(id) {
      this.$router.push({ path: "/home/siteDetail", query: { id: id } });
    },

    //提交搜索条件
    onClickButton() {
      this.params.keyword = this.searchValue;
      this.params.page = 1;
      // 场地方管理-列表
      this.listBySiteSupplierId();
    },


    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 场地方管理-列表
        that.listBySiteSupplierId();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.listBySiteSupplierId();
      }, 1000);
    },

    // 场地方管理-列表
    listBySiteSupplierId() {
      var that = this;
      that.$api
        .collectListAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            if (res.data.dataList.length > 0) {
              res.data.dataList.forEach((element) => {
                element.siteCharacteristics_name =
                  element.siteCharacteristics_name.split(",");
              });
            }
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.siteList = res.data.dataList;
            } else {
              that.siteList = [...that.siteList, ...res.data.dataList];
            }
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //场地方管理-上下架
    siteShelfStatus(id) {
      var that = this;
      that.$api
        .siteShelfStatusAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
              onClose() {
                //下拉刷新
                that.onRefresh();
              },
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //场地方管理-删除
    siteDelete(id) {
      var that = this;
      that.$api
        .siteDeleteAPI({ ids: id })
        .then(function (res) {
          if (res.data.code === 200) {
            //下拉刷新
            that.onRefresh();
            that.$Notify({
              type: "success",
              message: "操作成功",
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },

    //跳转发布场地界面
    toPlaceIssue() {
      this.$router.push({ path: "/place/placeIssue" });
    },

    //跳转编辑场地界面
    toPlaceEdit(id) {
      this.$router.push({ path: "/place/placeEdit", query: { id: id } });
    },
  },
};
</script>

<style lang="less" scoped>
.management_search {
  background: #eaeaea;
  padding: 10px 15px;
}

.van-search {
  padding: unset;
}

/deep/ .van-search__action {
  background: #2295ff;
  color: #fff;
  border-radius: 0px 5px 5px 0px;
}

// 列表菜单栏
.home_list {
  display: flex;
  flex-direction: column;

  .list_item {
    display: flex;
    flex-direction: column;
    padding: 0px 20px;

    .item_content {
      display: flex;
      flex-direction: row;
      padding-top: 10px;
      padding-bottom: 5px;

      .content_img {
        position: relative;
        width: 130px;
        height: 90px;
        border-radius: 3px;
        overflow: hidden;
        position: relative;

        div {
          position: absolute;
          background: rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #fff;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .van-icon {
          position: absolute;
          bottom: 5px;
          right: 5px;
          background: rgba(0, 0, 0, 0.5);
          padding: 5px;
          border-radius: 100%;
        }
      }

      .content_detail {
        width: 250px;
        display: flex;
        flex-flow: column; //垂直排列
        justify-content: space-between; //两端对齐
        margin-left: 10px;

        /deep/ .detail_tag {
          margin-right: 5px;
          display: flex;
          flex-wrap: wrap;

          .van-tag--plain {
            padding: 2px 3px;
            margin-right: 5px;
            margin-top: 5px;
          }

        }

        .detail_number {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          align-items: flex-end;

          .number {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
          }
        }
      }
    }
  }

  .item_action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 5px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f1f1f1;

    .van-button {
      padding: 5px 15px;
      border-radius: 3px;
      font-size: 14px;
    }

    .action_delete {
      color: #000 !important;
    }
  }
}

.management_push {
  position: fixed !important;
  bottom: 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/personal/collectList.vue